import ErrorBoundaryMessage from './ErrorBoundaryMessage';
export default ErrorBoundaryMessage;
